import { SubSubheaderSection } from 'src/app/components/Pages/PromotionalLandingPage/styles';

import { ImageTextContainer } from './styles';

export const ImageTextHeader = () => {
  return (
    <ImageTextContainer>
      <span>
        <SubSubheaderSection>
          We’re the pharmacy that delivers your prescriptions and over the counter meds, the same day, for free.
        </SubSubheaderSection>
        <img src="/public/big-red-heart.svg" alt="" />
      </span>
    </ImageTextContainer>
  );
};
